var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13024 11.3368C6.44096 11.0261 6.44096 10.5223 6.13024 10.2116L1.91894 6.00027L6.13024 1.78896C6.44096 1.47826 6.44096 0.974471 6.13024 0.663764C5.81952 0.353057 5.31574 0.353057 5.00502 0.663764L0.231117 5.43766C0.156511 5.51227 0.0990176 5.59831 0.0586367 5.69578C0.0182614 5.79326 -0.00192595 5.89476 -0.00192595 6.00027C-0.00192595 6.10578 0.0182614 6.20727 0.0586367 6.30475C0.0990176 6.40223 0.156511 6.48827 0.231117 6.56288L5.00502 11.3368C5.31574 11.6475 5.81952 11.6475 6.13024 11.3368Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/GoBack.7c4c548ac097aa13a7fb8e544939be28.svg";
export { ForwardRef as ReactComponent };